import gql from "graphql-tag"

export default gql`
  query CohortShareContextQuery($type: ShareContextType!, $typeId: Int!) {
    cohort: group(id: $typeId) {
      id
      # for visibility
      visibility
      # for gating
      access_ends
      registration_ends
      # for refetching perms when cached key changes
      status
      seats_available
      resource {
        id
        name
        short_description
        image_raw
      }
    }
    sharePermissions(context: { type: $type, type_id: $typeId }) {
      ... on ShareCohortPermissions {
        type
        type_id
        add_limit
        allow_manage
        manage_url
        allow_activate
        activate_contact_email
        share_access {
          access
          gated_reason
        }
        share_link_access {
          access
          gated_reason
        }
        share_add_access {
          access
          gated_reason
        }
        share_track_access {
          access
          gated_reason
        }
        invite_roles {
          cohort_viewer: viewer {
            url
            role
            gate_reason
          }
          cohort_observer: observer {
            url
            role
            gate_reason
          }
          cohort_learner: learner {
            url
            role
            gate_reason
          }
          cohort_moderator: moderator {
            url
            role
            gate_reason
          }
          cohort_teacher: teacher {
            url
            role
            gate_reason
          }
          cohort_course_editor: course_editor {
            url
            role
            gate_reason
          }
        }
        __typename
      }
    }
  }
`
